import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';

export const BRANCH_OPTIONS = [
  { value: 'somajiguda', label: 'Somajiguda' },
  { value: 'hitech', label: 'Hitec City' },
];

const ALL = BRANCH_OPTIONS.map((b) => b.value);
const STORAGE_KEY = 'yashoda.branch_filter';

const BranchContext = createContext({
  branches: ALL,
  setBranches: () => {},
  branchParam: undefined,
});

export const BranchProvider = ({ children }) => {
  const [branches, setBranches] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return ALL;
      const parsed = JSON.parse(raw);
      const valid = Array.isArray(parsed) ? parsed.filter((b) => ALL.includes(b)) : [];
      return valid.length ? valid : ALL;
    } catch {
      return ALL;
    }
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(branches)); } catch {}
  }, [branches]);

  const value = useMemo(() => {
    const isAll = branches.length === 0 || branches.length === ALL.length;
    return {
      branches,
      setBranches,
      branchParam: isAll ? undefined : branches.join(','),
    };
  }, [branches]);

  return <BranchContext.Provider value={value}>{children}</BranchContext.Provider>;
};

export const useBranch = () => useContext(BranchContext);
